// extracted by mini-css-extract-plugin
export var badge = "_hp-2";
export var detailsPanel = "_hp-0";
export var resultRow = "_hp-1";